/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_H2Inputs */

const es_landing_how_h2 = /** @type {(inputs: Landing_How_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú registras tu barco. Del resto nos ocupamos nosotros.`)
};

const gl_landing_how_h2 = /** @type {(inputs: Landing_How_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti rexistras o teu barco. Do resto encargámonos nós.`)
};

const en_landing_how_h2 = /** @type {(inputs: Landing_How_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You list your boat. We take care of the rest.`)
};

/**
* | output |
* | --- |
* | "You list your boat. We take care of the rest." |
*
* @param {Landing_How_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_how_h2 = /** @type {((inputs?: Landing_How_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_how_h2(inputs)
	if (locale === "en") return en_landing_how_h2(inputs)
	return es_landing_how_h2(inputs)
});